import React from "react";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

interface ToggleFilterProps {
  onClick: () => void;
}

const ToggleFilter: React.FC<ToggleFilterProps> = ({ onClick }) => {
  return (
    <button className="filter-icon ms-3 mb-3" onClick={onClick} >
      <FilterAltOutlinedIcon />
    </button>
  );
};

export default ToggleFilter;
